"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { CounterDisplay } from "@/components/counter-display";
import { useFirestoreScoredGames } from "@/hooks/useFirestoreScoredGames";
import { Watch, Megaphone } from "lucide-react";
export default function Home() {
  const $ = _c(15);
  const {
    scoredGames
  } = useFirestoreScoredGames();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none"><div className="relative w-[80%] sm:w-[70%] md:w-[60%] lg:w-[50%] aspect-square"><Image src="/drawables/mvplayer_background_small.webp" alt="" fill={true} priority={true} className="object-contain opacity-25" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="lg:hidden flex justify-center animate-in fade-in zoom-in duration-700 delay-300"><Image src="/drawables/scoreboard_preview.webp" alt="MVPlayer Scoreboard Preview" width={240} height={240} className="h-auto w-full max-w-[200px] sm:max-w-[240px] object-contain drop-shadow-2xl" priority={true} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="inline-block opacity-0 blur-md translate-y-12" style={{
      animation: "fadeSlideUnblur 1s ease-out 0.6s forwards"
    }}>You</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="inline-block opacity-0 blur-md translate-y-12" style={{
      animation: "fadeSlideUnblur 1s ease-out 0.8s forwards"
    }}> play</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-[#B0D18B] tracking-tighter font-sriracha inline-block opacity-0 blur-lg translate-y-12" style={{
      animation: "fadeSlideUnblur 1.2s ease-out 1.0s forwards"
    }}>, We</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] text-4xl tracking-tighter font-sriracha text-[#B0D18B] mb-12">{t2}{t3}{t4}<span className="text-[#B0D18B] tracking-tighter font-sriracha inline-block opacity-0 blur-lg translate-y-12" style={{
        animation: "fadeSlideUnblur 1.2s ease-out 1.2s forwards"
      }}> score!</span></h1>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      animation: "fadeSlideUnblur 1s ease-out 1.4s forwards"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="flex items-center justify-center gap-2 text-[#C4C8BA] text-sm sm:text-base"><span className="inline-block"><Image src="/drawables/sports_tennis_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.svg" alt="Tennis" width={16} height={16} className="inline-block w-4 h-4" /></span>{" Score Padel, Tennis & Badminton matches"}</p>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="flex items-center justify-center gap-2 text-[#C4C8BA] text-sm sm:text-base"><Watch className="inline-block w-4 h-4 text-[#B0D18B]" /> Control the Game from Your Wrist</p>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-8 space-y-2 text-center opacity-0 blur-md translate-y-8" style={t6}>{t7}{t8}<p className="flex items-center justify-center gap-2 text-[#C4C8BA] text-sm sm:text-base"><span className="inline-block"><Image src="/drawables/mobile_speaker_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.svg" alt="Speaker" width={16} height={16} className="inline-block w-4 h-4" /></span> Connect Up to 4 Devices</p></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      animation: "fadeSlideIn 0.8s ease-out 1.6s forwards"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="sm:mt-5 flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-6 lg:justify-center opacity-0 mt-5 translate-y-12 gap-x-4 gap-y-4 items-center justify-center" style={t10}><Link href="/get-started" className="inline-flex items-center justify-center gap-2 hover:bg-[#B0D18B]-800 hover:scale-105 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 active:scale-95 group w- text-sm font-normal font-geist bg-[#B0D18B] h-10 border-[#B0D18B] rounded-full mt-4 pr-4 pl-4 text-[#1E3702]"><span className="">Get Started</span></Link></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      animation: "fadeSlideUnblur 1s ease-out 2.2s forwards"
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== scoredGames) {
    t13 = <div className="animate-in fade-in duration-500"><section className="overflow-hidden relative"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-24"><div className="flex justify-center relative"><div className="lg:text-center text-center relative rounded-2xl p-4">{t0}{t1}{t5}{t9}{t11}<div className="leading-relaxed text-sm sm:text-base lg:text-lg font-medium text-[#C4C8BA] font-geist opacity-0 w-full mt-16 flex justify-center blur-md translate-y-8" style={t12}><CounterDisplay count={scoredGames} /></div></div></div></div></section></div>;
    $[13] = scoredGames;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  return t13;
}